<template>
  <div class="dashboard-period-selector">
    <div class="scope-toggle" v-if="showScope">
      <v-btn small :outlined="scope !== 'tree'" :color="scope === 'tree' ? 'primary' : ''" class="consolidated-btn" @click="$emit('update:scope', scope === 'tree' ? 'self' : 'tree')">
        <v-icon small left>mdi-file-tree</v-icon>
        {{ $t('org-dashboard.consolidated') }}
      </v-btn>
    </div>
    <div class="period-toggle">
      <v-btn-toggle :value="period" @change="$emit('update:period', $event)" mandatory dense class="period-btn-toggle">
        <v-btn small :value="'7d'" class="period-btn">{{ $t('org-dashboard.period-7d') }}</v-btn>
        <v-btn small :value="'30d'" class="period-btn">{{ $t('org-dashboard.period-30d') }}</v-btn>
        <v-btn small :value="'90d'" class="period-btn">{{ $t('org-dashboard.period-90d') }}</v-btn>
      </v-btn-toggle>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardPeriodSelector',
  props: {
    period: {
      type: String,
      default: '30d',
    },
    scope: {
      type: String,
      default: 'self',
    },
    showScope: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-period-selector {
  display: flex;
  align-items: center;
  gap: 12px;
}

.consolidated-btn {
  text-transform: none !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  height: 32px !important;
}

.period-btn-toggle {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.period-btn {
  text-transform: none !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  min-width: 40px !important;
  height: 32px !important;
}

.v-btn--active {
  background-color: rgba(#FF5722, 0.1) !important;
  color: #FF5722 !important;
}
</style>
